export default "__VITE_ASSET__a59200c5__"